import styled from "styled-components";

export const StyledError = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-gray-1);
  .error-container {
    display: flex;

    & > .box {
      background-color: var(--bg-gray-normal);
      width: calc(51.2rem - 9.6rem);
      height: calc(46rem - 9.6rem);
      padding: 4.8rem 4.8rem 4rem 4.8rem;
      box-shadow: 0px 0px 8px 0px rgba(17, 17, 17, 0.08);
      border-radius: 1.6rem;
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-between;
      & > .top {
        display: flex;
        flex-flow: column nowrap;
        gap: 4rem;
        & > .logo {
          width: 100%;
          height: 4.8rem;
          display: flex;
          align-items: center;
          & > svg {
            width: 4.8rem;
            height: 4.8rem;
          }
        }
        & > .main {
          width: 100%;
          height: max-content;
          display: flex;
          flex-flow: column nowrap;
          /* align-items: center; */
          justify-content: center;
          gap: 0.8rem;
          .title-box {
            display: flex;
            gap: 0.8rem;
            & > .title {
              font: var(--headline-small);
              color: var(--pri-blue-9);
            }
          }
          .description {
            position: relative;
            z-index: 1;
            padding-left: 4rem;
            font: var(--body-small-400);
            color: var(--pri-blue-9);
          }
        }
      }
      & > .bottom {
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-end;
        gap: 2.8rem;
        & > .code {
          color: var(--bg-gray-1);
          text-align: right;
          font-family: Pretendard;
          font-size: 120px;
          font-style: normal;
          font-weight: 900;
          line-height: 128px;
        }
        & > .btn-wrap {
          display: flex;
          justify-content: center;
          margin-top: auto;
          width: 100%;
          /* & > button {
            display: flex;
            gap: 0.4rem;
            justify-content: center;
            align-items: center;
            box-sizing: content-box;
            background-color: var(--pri-blue-4);
            color: #fff;
            border: none;
            cursor: pointer;
            width: 100%;
            padding: 0.8rem 1.2rem;
            font: var(--button-large);
            border-radius: 0.4rem;
          } */
        }
      }
    }
  }
`;
